import axios from 'axios';

const baseURL = window.runtime_configs?.server_host;
// const baseURL = 'https://sbqrpay.zalopay.vn/home';

const axiosInstance = axios.create({
	baseURL,
	timeout: 35000,
});

const RequestGet = async (path, header = {}) => {
  const token = header && header.token

    try {
        const response = await axiosInstance.get(path, {
            headers: {
				      Authorization: ` Bearer ${token}`,
              'Content-Type': 'application/json'
			},
        });

        return response.data

    } catch (err) {
        return {
            err: -1,
            message: 'Connection failed. Please try again'
          }
    }
}

const RequestPost = async (path, payload, header) => {
  const token = header && header.token

    try {
        const response = await axiosInstance.post(path, payload, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
        return response.data
      } catch (err) {
        return {
          err: -1,
          message: 'Connection failed. Please try again'
        }
      }
}

export { RequestGet, RequestPost }
